/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfGetStaffTeamSummariesOutput } from "../models/AjaxResponseOfGetStaffTeamSummariesOutput";
import type { AjaxResponseOfStaffTeamDetailsDto } from "../models/AjaxResponseOfStaffTeamDetailsDto";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class StaffAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfGetStaffTeamSummariesOutput Success
   * @throws ApiError
   */
  public getTeamSummaries({
    filter,
    isActiveFilter,
    hasPendingDesignRequests,
    hasPendingPaidTrafficOrders,
    applicationUniqueIdentification,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    isActiveFilter?: boolean;
    hasPendingDesignRequests?: boolean;
    hasPendingPaidTrafficOrders?: boolean;
    applicationUniqueIdentification?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfGetStaffTeamSummariesOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/staff",
      query: {
        filter: filter,
        isActiveFilter: isActiveFilter,
        hasPendingDesignRequests: hasPendingDesignRequests,
        hasPendingPaidTrafficOrders: hasPendingPaidTrafficOrders,
        applicationUniqueIdentification: applicationUniqueIdentification,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns AjaxResponseOfStaffTeamDetailsDto Success
   * @throws ApiError
   */
  public getTeamDetails({
    teamId,
    startDate,
    endDate,
  }: {
    teamId: number;
    startDate?: string;
    endDate?: string;
  }): CancelablePromise<AjaxResponseOfStaffTeamDetailsDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/staff/{teamId}",
      path: {
        teamId: teamId,
      },
      query: {
        startDate: startDate,
        endDate: endDate,
      },
    });
  }
}
